module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_innlandet_neg.849aef04.png";